import { APIRouteMap } from '@core/models/api';
import { environment } from '@environment';

export const INTERCEPTOR_CONFIG = {
  jwtInterceptor: {
    skipUrls: [
      APIRouteMap.CONTENT_GETTRANSLATES,
      APIRouteMap.CONTENT_GETLANGUAGES,

      // Добавляем только если enabled = true
      ...(environment.mockServiceWorker.enabled
        ? environment.mockServiceWorker.endpoints.map((x) => x.url)
        : []),
    ],
  },
  langInterceptor: {
    skipUrls: [APIRouteMap.CONTENT_GETLANGUAGES],
  },
  baseUrlInterceptor: {
    skipUrls: [
      APIRouteMap.PSP_APPLEPAY_GETPAYMENTSESSION,
      APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONGET,
      APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONRESENDEMAIL,
    ],
  },
  ajaxHeaderInterceptor: {
    skipUrls: [
      APIRouteMap.PSP_APPLEPAY_GETPAYMENTSESSION,
      APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONGET,
      APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONRESENDEMAIL,
    ],
  },
};
